import * as React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { ROLE_HOME, type Role } from "@/lib/auth";

export const Route = createFileRoute("/auth/callback")({
  head: () => ({
    meta: [
      { title: "Đang đăng nhập… — Ezyclass" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: OAuthCallbackPage,
});

/**
 * Đích quay về sau đăng nhập Google (OAuth full-page).
 * Chờ session được khôi phục, gán vai trò mặc định (Học sinh) cho tài khoản
 * mới qua ensureOAuthUserRole, rồi điều hướng tới portal tương ứng.
 */
function OAuthCallbackPage() {
  React.useEffect(() => {
    let cancelled = false;
    (async () => {
      // Chờ OAuth quay về khôi phục session (localStorage đồng bộ sau redirect)
      let sessionUser: { id: string } | null = null;
      for (let i = 0; i < 24; i++) {
        const { data } = await supabase.auth.getSession();
        if (data.session?.user) {
          sessionUser = { id: data.session.user.id };
          break;
        }
        await new Promise((r) => setTimeout(r, 250));
      }
      if (cancelled) return;

      if (!sessionUser) {
        window.location.replace("/login");
        return;
      }

      // Dọn flag demo nếu còn (tài khoản Google là tài khoản thật)
      window.localStorage.removeItem("ezyclass.demo.role");

      try {
        const { ensureOAuthUserRole } = await import("@/lib/auth-bootstrap.functions");
        const res = await ensureOAuthUserRole();
        const role = (res.role ?? "student") as Role;

        // Ưu tiên đích đã lưu từ /login?redirect=... (cùng origin)
        const saved = window.sessionStorage.getItem("ezyclass.oauth_redirect");
        window.sessionStorage.removeItem("ezyclass.oauth_redirect");
        const safe =
          saved && saved.startsWith("/") && !saved.startsWith("/login") && !saved.startsWith("/auth")
            ? saved
            : null;

        window.location.replace(safe ?? ROLE_HOME[role]);
      } catch (err) {
        console.error("[oauth-callback] ensureOAuthUserRole failed:", err);
        window.location.replace("/login");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="min-h-[100dvh] grid place-items-center bg-white dark:bg-slate-900">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="size-6 animate-spin text-slate-400" />
        <p className="text-sm text-slate-500 dark:text-slate-400">Đang đăng nhập…</p>
      </div>
    </div>
  );
}
